export default __webpack_public_path__ + "static/media/modal6.64a0165e.jpg";